import { render } from "./Store.vue?vue&type=template&id=22b27ff6&scoped=true"
import script from "../js/store.js?vue&type=script&lang=js"
export * from "../js/store.js?vue&type=script&lang=js"

import "./Store.vue?vue&type=style&index=0&id=22b27ff6&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b27ff6"]])

export default __exports__